export const conversionColorMapping = {
  // Document conversions
  pdfToWord: {
    text: 'text-gray-600',
    border: 'border-blue-500',
    icon: 'text-blue-500',
    dragActive: {
      border: 'border-blue-500',
      background: 'bg-blue-50/30',
      text: 'text-blue-600'
    }
  },
  wordToPdf: {
    text: 'text-gray-600',
    border: 'border-red-500',
    icon: 'text-red-500',
    dragActive: {
      border: 'border-red-600',
      background: 'bg-red-50',
      text: 'text-red-600'
    }
  },
  // Add new document conversions
  excelToPdf: {
    text: 'text-gray-600',
    border: 'border-emerald-500',
    icon: 'text-emerald-500',
    dragActive: {
      border: 'border-emerald-600',
      background: 'bg-emerald-50',
      text: 'text-emerald-600'
    }
  },
  pdfToExcel: {
    text: 'text-gray-600',
    border: 'border-green-500',
    icon: 'text-green-500',
    dragActive: {
      border: 'border-green-600',
      background: 'bg-green-50',
      text: 'text-green-600'
    }
  },
  txtToPdf: {
    text: 'text-gray-600',
    border: 'border-slate-500',
    icon: 'text-slate-500',
    dragActive: {
      border: 'border-slate-600',
      background: 'bg-slate-50',
      text: 'text-slate-600'
    }
  },
  pdfToTxt: {
    text: 'text-gray-600',
    border: 'border-zinc-500',
    icon: 'text-zinc-500',
    dragActive: {
      border: 'border-zinc-600',
      background: 'bg-zinc-50',
      text: 'text-zinc-600'
    }
  },
  mdToPdf: {
    text: 'text-gray-600',
    border: 'border-sky-500',
    icon: 'text-sky-500',
    dragActive: {
      border: 'border-sky-600',
      background: 'bg-sky-50',
      text: 'text-sky-600'
    }
  },
  pdfToMd: {
    text: 'text-gray-600',
    border: 'border-blue-400',
    icon: 'text-blue-400',
    dragActive: {
      border: 'border-blue-500',
      background: 'bg-blue-50',
      text: 'text-blue-500'
    }
  },
  pptToPdf: {
    text: 'text-gray-600',
    border: 'border-orange-500',
    icon: 'text-orange-500',
    dragActive: {
      border: 'border-orange-600',
      background: 'bg-orange-50',
      text: 'text-orange-600'
    }
  },
  zipToSevenZip: {
    text: 'text-gray-600',
    border: 'border-violet-500',
    icon: 'text-violet-500',
    dragActive: {
      border: 'border-violet-600',
      background: 'bg-violet-50',
      text: 'text-violet-600'
    }
  },
  // Image conversions
  svgToPng: {
    text: 'text-gray-600',
    border: 'border-cyan-500',
    icon: 'text-cyan-500',
    dragActive: {
      border: 'border-cyan-600',
      background: 'bg-cyan-50',
      text: 'text-cyan-600'
    }
  },
  gifToPng: {
    text: 'text-gray-600',
    border: 'border-fuchsia-500',
    icon: 'text-fuchsia-500',
    dragActive: {
      border: 'border-fuchsia-600',
      background: 'bg-fuchsia-50',
      text: 'text-fuchsia-600'
    }
  },
  // Video conversions
  aviToMp4: {
    text: 'text-gray-600',
    border: 'border-cyan-500',
    icon: 'text-cyan-500',
    dragActive: {
      border: 'border-cyan-600',
      background: 'bg-cyan-50',
      text: 'text-cyan-600'
    }
  },
  mp3ToMp4: {
    text: 'text-gray-600',
    border: 'border-teal-500',
    icon: 'text-teal-500',
    dragActive: {
      border: 'border-teal-600',
      background: 'bg-teal-50',
      text: 'text-teal-600'
    }
  },
  // Add missing conversions
  jpegToPng: {
    text: 'text-gray-600',
    border: 'border-indigo-500',
    icon: 'text-indigo-500',
    dragActive: {
      border: 'border-indigo-600',
      background: 'bg-indigo-50',
      text: 'text-indigo-600'
    }
  },
  webpToPng: {
    text: 'text-gray-600',
    border: 'border-pink-500',
    icon: 'text-pink-500',
    dragActive: {
      border: 'border-pink-600',
      background: 'bg-pink-50',
      text: 'text-pink-600'
    }
  },
  dwgToPdf: {
    text: 'text-gray-600',
    border: 'border-rose-500',
    icon: 'text-rose-500',
    dragActive: {
      border: 'border-rose-600',
      background: 'bg-rose-50',
      text: 'text-rose-600'
    }
  },
  pngToJpeg: {
    text: 'text-gray-600',
    border: 'border-purple-500',
    icon: 'text-purple-500',
    dragActive: {
      border: 'border-purple-600',
      background: 'bg-purple-50',
      text: 'text-purple-600'
    }
  },
  mp4ToGif: {
    text: 'text-gray-600',
    border: 'border-pink-500',
    icon: 'text-pink-500',
    dragActive: {
      border: 'border-pink-600',
      background: 'bg-pink-50',
      text: 'text-pink-600'
    }
  },
  zipToRar: {
    text: 'text-gray-600',
    border: 'border-amber-500',
    icon: 'text-amber-500',
    dragActive: {
      border: 'border-amber-600',
      background: 'bg-amber-50',
      text: 'text-amber-600'
    }
  },
  rarToZip: {
    text: 'text-gray-600',
    border: 'border-orange-500',
    icon: 'text-orange-500',
    dragActive: {
      border: 'border-orange-600',
      background: 'bg-orange-50',
      text: 'text-orange-600'
    }
  },
  sevenZToZip: {
    text: 'text-gray-600',
    border: 'border-lime-500',
    icon: 'text-lime-500',
    dragActive: {
      border: 'border-lime-600',
      background: 'bg-lime-50',
      text: 'text-lime-600'
    }
  },
  csvToJson: {
    text: 'text-gray-600',
    border: 'border-emerald-500',
    icon: 'text-emerald-500',
    dragActive: {
      border: 'border-emerald-600',
      background: 'bg-emerald-50',
      text: 'text-emerald-600'
    }
  },
  jsonToCsv: {
    text: 'text-gray-600',
    border: 'border-teal-500',
    icon: 'text-teal-500',
    dragActive: {
      border: 'border-teal-600',
      background: 'bg-teal-50',
      text: 'text-teal-600'
    }
  },
  epubToPdf: {
    text: 'text-gray-600',
    border: 'border-violet-500',
    icon: 'text-violet-500',
    dragActive: {
      border: 'border-violet-600',
      background: 'bg-violet-50',
      text: 'text-violet-600'
    }
  },
  pdfToEpub: {
    text: 'text-gray-600',
    border: 'border-indigo-500',
    icon: 'text-indigo-500',
    dragActive: {
      border: 'border-indigo-600',
      background: 'bg-indigo-50',
      text: 'text-indigo-600'
    }
  },
  dxfToPdf: {
    text: 'text-gray-600',
    border: 'border-rose-500',
    icon: 'text-rose-500',
    dragActive: {
      border: 'border-rose-600',
      background: 'bg-rose-50',
      text: 'text-rose-600'
    }
  },
  pngToGif: {
    text: 'text-gray-600',
    border: 'border-pink-500',
    icon: 'text-pink-500',
    dragActive: {
      border: 'border-pink-600',
      background: 'bg-pink-50',
      text: 'text-pink-600'
    }
  },
  tiffToJpeg: {
    text: 'text-gray-600',
    border: 'border-cyan-500',
    icon: 'text-cyan-500',
    dragActive: {
      border: 'border-cyan-600',
      background: 'bg-cyan-50',
      text: 'text-cyan-600'
    }
  },
  jpegToTiff: {
    text: 'text-gray-600',
    border: 'border-teal-500',
    icon: 'text-teal-500',
    dragActive: {
      border: 'border-teal-600',
      background: 'bg-teal-50',
      text: 'text-teal-600'
    }
  },
  pngToSvg: {
    text: 'text-gray-600',
    border: 'border-purple-500',
    icon: 'text-purple-500',
    dragActive: {
      border: 'border-purple-600',
      background: 'bg-purple-50',
      text: 'text-purple-600'
    }
  },
  bmpToJpeg: {
    text: 'text-gray-600',
    border: 'border-sky-500',
    icon: 'text-sky-500',
    dragActive: {
      border: 'border-sky-600',
      background: 'bg-sky-50',
      text: 'text-sky-600'
    }
  },

  // Audio/Video conversions
  mp4ToMp3: {
    text: 'text-gray-600',
    border: 'border-blue-500',
    icon: 'text-blue-500',
    dragActive: {
      border: 'border-blue-600',
      background: 'bg-blue-50',
      text: 'text-blue-600'
    }
  },
  '7zToZip': {
    text: 'text-gray-600',
    border: 'border-yellow-500',
    icon: 'text-yellow-500',
    dragActive: {
      border: 'border-yellow-600',
      background: 'bg-yellow-50',
      text: 'text-yellow-600'
    }
  },
  'zipTo7z': {
    text: 'text-gray-600',
    border: 'border-lime-500',
    icon: 'text-lime-500',
    dragActive: {
      border: 'border-lime-600',
      background: 'bg-lime-50',
      text: 'text-lime-600'
    }
  },
  tarToZip: {
    text: 'text-gray-600',
    border: 'border-green-500',
    icon: 'text-green-500',
    dragActive: {
      border: 'border-green-600',
      background: 'bg-green-50',
      text: 'text-green-600'
    }
  },
  zipToTar: {
    text: 'text-gray-600',
    border: 'border-emerald-500',
    icon: 'text-emerald-500',
    dragActive: {
      border: 'border-emerald-600',
      background: 'bg-emerald-50',
      text: 'text-emerald-600'
    }
  },
  tarGzToZip: {
    text: 'text-gray-600',
    border: 'border-teal-500',
    icon: 'text-teal-500',
    dragActive: {
      border: 'border-teal-600',
      background: 'bg-teal-50',
      text: 'text-teal-600'
    }
  },
  zipToTarGz: {
    text: 'text-gray-600',
    border: 'border-cyan-500',
    icon: 'text-cyan-500',
    dragActive: {
      border: 'border-cyan-600',
      background: 'bg-cyan-50',
      text: 'text-cyan-600'
    }
  },

  // Ebook conversions
  mobiToEpub: {
    text: 'text-gray-600',
    border: 'border-fuchsia-500',
    icon: 'text-fuchsia-500',
    dragActive: {
      border: 'border-fuchsia-600',
      background: 'bg-fuchsia-50',
      text: 'text-fuchsia-600'
    }
  },
  epubToMobi: {
    text: 'text-gray-600',
    border: 'border-pink-500',
    icon: 'text-pink-500',
    dragActive: {
      border: 'border-pink-600',
      background: 'bg-pink-50',
      text: 'text-pink-600'
    }
  },

  // CAD/Design conversions
  pdfToDwg: {
    text: 'text-gray-600',
    border: 'border-indigo-500',
    icon: 'text-indigo-500',
    dragActive: {
      border: 'border-indigo-600',
      background: 'bg-indigo-50',
      text: 'text-indigo-600'
    }
  },
  svgToDxf: {
    text: 'text-gray-600',
    border: 'border-violet-500',
    icon: 'text-violet-500',
    dragActive: {
      border: 'border-violet-600',
      background: 'bg-violet-50',
      text: 'text-violet-600'
    }
  },
  dxfToSvg: {
    text: 'text-gray-600',
    border: 'border-purple-500',
    icon: 'text-purple-500',
    dragActive: {
      border: 'border-purple-600',
      background: 'bg-purple-50',
      text: 'text-purple-600'
    }
  },

  // Data conversions
  csvToExcel: {
    text: 'text-gray-600',
    border: 'border-teal-500',
    icon: 'text-teal-500',
    dragActive: {
      border: 'border-teal-600',
      background: 'bg-teal-50',
      text: 'text-teal-600'
    }
  },
  excelToCsv: {
    text: 'text-gray-600',
    border: 'border-cyan-500',
    icon: 'text-cyan-500',
    dragActive: {
      border: 'border-cyan-600',
      background: 'bg-cyan-50',
      text: 'text-cyan-600'
    }
  },

  // Other conversions
  htmlToPdf: {
    text: 'text-gray-600',
    border: 'border-orange-500',
    icon: 'text-orange-500',
    dragActive: {
      border: 'border-orange-600',
      background: 'bg-orange-50',
      text: 'text-orange-600'
    }
  },
  latexToPdf: {
    text: 'text-gray-600',
    border: 'border-rose-500',
    icon: 'text-rose-500',
    dragActive: {
      border: 'border-rose-600',
      background: 'bg-rose-50',
      text: 'text-rose-600'
    }
  },
  markdownToPdf: {
    text: 'text-gray-600',
    border: 'border-sky-500',
    icon: 'text-sky-500',
    dragActive: {
      border: 'border-sky-600',
      background: 'bg-sky-50',
      text: 'text-sky-600'
    }
  },
  mdToHtml: {
    text: 'text-gray-600',
    border: 'border-blue-500',
    icon: 'text-blue-500',
    dragActive: {
      border: 'border-blue-600',
      background: 'bg-blue-50',
      text: 'text-blue-600'
    }
  }, 

  // Special image conversion tools

  imagesToPdf: {
    text: 'text-gray-600',
    border: 'border-purple-500',
    icon: 'text-purple-500',
    dragActive: {
      border: 'border-purple-600',
      background: 'bg-purple-50/30',
      text: 'text-purple-600'
    }
  },
  pdfToImages: {
    text: 'text-gray-600',
    border: 'border-indigo-500',
    icon: 'text-indigo-500',
    dragActive: {
      border: 'border-indigo-600',
      background: 'bg-indigo-50/30',
      text: 'text-indigo-600'
    }
  },
};

// Default theme using the exact brand color (bright blue from Confidence/Privacy button)
export const defaultTheme = {
  text: 'text-gray-600',
  border: 'border-gray-200',
  icon: 'text-gray-400',
  dragActive: {
    border: 'border-primary-400',
    background: 'bg-primary-50',
    text: 'text-primary-600'
  }
};
